import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Monitor, Battery, Cpu, Wifi } from 'lucide-react';
import styles from './DeviceMonitor.module.css';

const DeviceMonitor = () => {
    const navigate = useNavigate();

    // Hardcoded placeholder data for API rollout
    const devices = [
        { deviceId: "DEV-001", status: "Online", battery: "85%", availableRam: "1.4GB", pending: 0 },
        { deviceId: "DEV-002", status: "Online", battery: "42%", availableRam: "0.8GB", pending: 12 }
    ];

    return (
        <div className="p-8 bg-slate-50 min-h-screen">
            <div className={`${styles.fadeIn}`}>
                <button
                    onClick={() => navigate('/dashboard/biometric-dev')}
                    className="flex items-center gap-2 text-slate-600 hover:text-blue-600 transition-colors mb-8 font-medium"
                >
                    <ArrowLeft size={20} />
                    Back to Dashboard
                </button>

                <div className={`${styles.glassStrong} rounded-3xl p-8 mb-8`}>
                    <div className="flex items-center gap-4 mb-2">
                        <div className="p-3 bg-blue-600 rounded-2xl text-white shadow-lg">
                            <Monitor size={32} />
                        </div>
                        <div>
                            <h1 className={`text-4xl font-bold ${styles.gradientText}`}>Device Monitoring</h1>
                            <p className="text-slate-600">Hardware health & synchronization diagnostics</p>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {devices.map((device) => (
                        <div key={device.deviceId} className={`${styles.glassStrong} p-6 rounded-2xl border-l-4 border-blue-500 shadow-sm transition-all hover:translate-y-[-4px] hover:shadow-xl`}>
                            <div className="flex justify-between items-start mb-6">
                                <div>
                                    <h4 className="font-bold text-lg text-slate-900">Device ID: {device.deviceId}</h4>
                                    <div className="flex items-center gap-2 mt-1">
                                        <Wifi size={14} className="text-emerald-500" />
                                        <span className="text-xs text-slate-500 font-medium font-mono uppercase tracking-wider">Linked Center</span>
                                    </div>
                                </div>
                            </div>

                            <div className="grid grid-cols-2 gap-4 text-sm">
                                <div className="flex flex-col gap-1">
                                    <div className="flex items-center gap-2 text-slate-500">
                                        <Battery size={14} />
                                        <span className="text-xs font-medium">Battery</span>
                                    </div>
                                    <span className={`font-bold text-lg text-slate-900`}>{device.battery}</span>
                                </div>
                                <div className="flex flex-col gap-1">
                                    <div className="flex items-center gap-2 text-slate-500">
                                        <Cpu size={14} />
                                        <span className="text-xs font-medium">RAM Status</span>
                                    </div>
                                    <span className="font-bold text-lg text-slate-900 font-mono">{device.availableRam}</span>
                                </div>
                            </div>

                            <div className="mt-6 pt-4 border-t border-slate-100 flex justify-between items-center">
                                <div className="flex flex-col">
                                    <span className="text-[10px] text-slate-400 font-medium uppercase tracking-tight">API Status</span>
                                    <span className="text-xs text-slate-600 font-semibold">T-Minus 12-15 Days</span>
                                </div>
                                <div className={`text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-wider bg-blue-100 text-blue-700 border border-blue-200`}>
                                    {device.status}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default DeviceMonitor;
